var _style, _g, _g2, _g3, _path, _defs, _defs2, _circle, _defs3, _g4, _g5, _g6, _path2, _rect, _rect2, _path3, _g7, _defs4, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _line, _g17, _line2, _path4, _path5, _g18, _polygon, _path6, _path7, _g19, _g20, _g21, _path8, _path9, _path10, _path11, _line3, _line4, _polygon2, _path12, _defs5, _polygon3, _path13, _polygon4, _g22, _path14, _path15, _path16, _line5, _line6, _path17, _path18, _line7, _path19, _path20, _path21, _path22, _line8, _path23, _g23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutUs2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#5E7FC4;}\r\n\t.st2{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st3{fill:#A9B7E6;stroke:#1D2637;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st4{fill:#7D97CF;}\r\n\t\r\n\t\t.st5{clip-path:url(#SVGID_00000144304477280776406240000006154172410410856116_);fill:#A9B7E6;stroke:#1D2637;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st6{clip-path:url(#SVGID_00000031179836509335929430000007744990672084228264_);}\r\n\t.st7{fill:#F0F3FB;}\r\n\t.st8{clip-path:url(#SVGID_00000091724985485895922220000008296363470831126149_);}\r\n\t.st9{fill:none;}\r\n\t.st10{fill:#9FAFE3;}\r\n\t.st11{fill:#5975CE;}\r\n\t.st12{fill:#E9EDF9;}\r\n\t.st13{clip-path:url(#SVGID_00000084510257833979747820000012998591955347436203_);fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st14{fill:none;stroke:#1D2637;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st15{fill:#C2CEE8;}\r\n\t.st16{fill:#BDC8EC;}\r\n\t.st17{fill:#3860B6;}\r\n\t.st18{fill:#7289D6;}\r\n\t.st19{fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st20{fill:#1D2637;}\r\n\t.st21{fill:#1444A9;}\r\n\t.st22{fill:#879FD3;}\r\n\t.st23{fill:#0A3CA5;}\r\n\t.st24{fill:#3B62B7;}\r\n\t.st25{fill:#BFCCE8;}\r\n\t.st26{fill:#B4C1E9;}\r\n\t.st27{fill:none;stroke:#141D2F;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st28{fill:#141D2F;}\r\n\t.st29{fill:#0034A1;}\r\n\t.st30{fill:#1C4AAB;}\r\n\t.st31{fill:#5C77CF;}\r\n\t.st32{clip-path:url(#SVGID_00000058560449653358466320000002166605372485156016_);fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st33{fill:#1A48AA;}\r\n\t.st34{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M435.5,464.2c0,0,177.4,2.6,176.5,1.7c0,0,26.4-73.1,26.9-121.5c-1.7,1-4,1.6-6.5,1.6 c-5.5,0-9.9-2.9-9.9-6.5c0-3.6,4.4-6.5,9.9-6.5c2.4,0,4.5,0.5,6.2,1.5c-1.3-17.3-7.1-29.8-20.4-31.8c-4.4-0.7-8.6-0.5-12.6,0.4 c0.4,0.9,0.8,1.9,1,3c0.8,4.4-0.8,8.4-3.7,8.9c-2.9,0.5-5.9-2.6-6.7-7c-0.1-0.5-0.1-0.9-0.2-1.4c-32.8,17-51.1,78.4-51.1,78.4 s-8.7-46.7-36.2-39.3c-4.2,1.1-8.3,3.2-12.2,5.9c1.4,1.8,2.4,4.1,2.9,6.7c1.2,6.3-1.2,12-5.3,12.8c-3.9,0.7-7.9-3.2-9.3-8.8 C454.9,395.5,435.5,464.2,435.5,464.2z M606.9,375.3c0-3.3,4.1-6,9.2-6c5.1,0,9.2,2.7,9.2,6s-4.1,6-9.2,6 C611,381.3,606.9,378.6,606.9,375.3z M584.6,328.4c4.6-0.9,9.3,4.1,10.6,11.1s-1.3,13.3-5.9,14.2c-4.6,0.9-9.3-4.1-10.6-11.1 C577.4,335.6,580,329.3,584.6,328.4z M520.3,414.4c3.6-2.7,7.9-2.9,9.6-0.6c1.7,2.3,0.3,6.4-3.3,9.1c-3.6,2.7-7.9,2.9-9.6,0.6 C515.3,421.1,516.7,417.1,520.3,414.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 620.6,
    y1: 309.7,
    x2: 565.5,
    y2: 457.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M515.2,364.2c-0.5,1.6-21,76.6-21,76.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 520.6,
    y1: 383.8,
    x2: 507.1,
    y2: 394
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 601.6,
    y1: 327.2,
    x2: 607.8,
    y2: 343.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 604.1,
    y1: 393.2,
    x2: 587.1,
    y2: 404.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M121.5,396.7l6.6,69.2H96.3l-14.8-62.6c-2.6-11,4.3-22.1,15.4-24.5c1.5-0.3,3-0.5,4.4-0.5 C111.5,378.3,120.5,386.1,121.5,396.7z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 111.9,
    y1: 465.6,
    x2: 101.1,
    y2: 398.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 111.4,
    y1: 411.1,
    x2: 105.3,
    y2: 422.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 97,
    y1: 436.3,
    x2: 108.5,
    y2: 445
  }))), /*#__PURE__*/React.createElement("g", null, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M660.2,439.1c0,2.7-0.7,5.4-2.2,7.9l-11.4,18.5h-25.2l9.4-30.7c2.7-8.9,12.9-13.2,21.2-8.9 C657.2,428.4,660.2,433.6,660.2,439.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 633.9,
    y1: 465.4,
    x2: 644.8,
    y2: 439.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M636,444.8c0.1,0.3,2.3,9,2.3,9"
  }))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M560.1,465.7H605c0.5-1.1,0.8-2.3,1.2-3.4c1.9-6.8,1.3-13.7-1.1-19.4l-7.2,1.5l4.1-6.7 c-2.9-3.8-6.8-6.7-11.6-8c-8-2.2-16.3,0.5-22.4,6.4l5.3,12.5l-10.1-6.4c-1.3,2.3-2.4,4.8-3.2,7.4 C558.6,455.1,558.7,460.7,560.1,465.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M560.1,465.8H605c0.5-1.1,0.8-2.3,1.2-3.4c1.9-6.8,1.3-13.7-1.1-19.4l-7.2,1.5l4.1-6.7 c-2.9-3.8-6.8-6.7-11.6-8c-8-2.2-16.3,0.5-22.4,6.4l5.3,12.5l-10.1-6.4c-1.3,2.3-2.4,4.8-3.2,7.4 C558.6,455.1,558.7,460.8,560.1,465.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000171710685455260134840000015462280326340755600_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000171710685455260134840000015462280326340755600_)",
      fill: "#A9B7E6",
      stroke: "#1D2637",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 593.2,
    y1: 427.1,
    x2: 578.1,
    y2: 466.1
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000171710685455260134840000015462280326340755600_)",
      fill: "#A9B7E6",
      stroke: "#1D2637",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 608.5,
    y1: 453.5,
    x2: 598.2,
    y2: 455.1
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000171710685455260134840000015462280326340755600_)",
      fill: "#A9B7E6",
      stroke: "#1D2637",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 574.7,
    y1: 428.9,
    x2: 576.8,
    y2: 436.6
  }))))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000173880045248768965540000016532403873758453134_",
    x: 100.2,
    y: 52.6,
    width: 518.3,
    height: 413.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000155848315033079338590000014970956330225837220_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173880045248768965540000016532403873758453134_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000155848315033079338590000014970956330225837220_)"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 373.9,
    cy: 305.2,
    r: 189.3
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000029765118934537160020000000928590215437294218_",
    cx: 373.9,
    cy: 305.3,
    r: 189.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178900226206509708040000016678843276815512750_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029765118934537160020000000928590215437294218_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178900226206509708040000016678843276815512750_)"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "343.3,117.6 343.2,114.7 343,111.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "344.9,109.8 345.3,114.7 345.4,119.6 341.3,119.6 341.2,114.9 340.8,110.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "342.6,108 342.2,105.1 341.7,102.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "343.3,100.1 344.2,104.9 344.9,109.8 340.8,110.2 340.2,105.5 339.4,100.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "340.9,98.6 340.2,95.7 339.4,93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "340.8,90.6 342.2,95.3 343.3,100.1 339.4,100.9 338.3,96.3 336.9,91.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M338.2,89.3c-0.3-0.9-0.6-1.8-1-2.7l-1.1-2.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M337.3,81.4c0.7,1.5,1.3,3,1.9,4.5c0.6,1.5,1.1,3.1,1.6,4.6l-3.9,1.3c-0.5-1.5-1-3-1.6-4.4 c-0.6-1.4-1.2-2.9-1.8-4.3L337.3,81.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M334.6,80.4c-0.8-1.8-1.7-3.5-2.6-5.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M332.8,72.6c0.8,1.4,1.6,2.9,2.3,4.3c0.8,1.5,1.4,3,2.1,4.4l-3.7,1.7c-0.7-1.4-1.3-2.9-2-4.2 c-0.8-1.4-1.4-2.8-2.2-4.1L332.8,72.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M330.1,72c-1-1.7-2.1-3.3-3.1-4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M327.5,64.4c1.9,2.7,3.7,5.4,5.3,8.2l-3.5,2c-1.6-2.7-3.3-5.4-5.1-7.9L327.5,64.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "324.7,64 323.9,62.8 322.9,61.7 321.1,59.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M321.4,56.7c2.2,2.4,4.2,5,6.1,7.7l-3.3,2.4c-1.8-2.5-3.8-5-5.9-7.3L321.4,56.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M318.6,56.6c-1.3-1.4-2.7-2.8-4-4.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M314.5,49.7c1.2,1.1,2.4,2.3,3.5,3.4c1.2,1.1,2.2,2.4,3.3,3.6l-3.1,2.7c-1-1.2-2.1-2.4-3.2-3.4 c-1.1-1.1-2.2-2.2-3.4-3.3L314.5,49.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M311.7,49.9c-1.4-1.3-2.9-2.5-4.4-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M307,43.4l2,1.5l1.9,1.6c0.6,0.5,1.3,1,1.9,1.6l1.8,1.7l-2.8,3l-1.7-1.6c-0.6-0.5-1.2-1-1.8-1.5 l-1.8-1.5l-1.9-1.4L307,43.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M304.3,43.8c-1.6-1.1-3.2-2.2-4.8-3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M298.9,37.9l2.1,1.3c0.7,0.4,1.4,0.9,2,1.4l2,1.4l2,1.5l-2.5,3.3l-1.9-1.4l-1.9-1.3 c-0.6-0.4-1.3-0.9-1.9-1.3l-2-1.2L298.9,37.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M296.2,38.5c-1.7-0.9-3.4-1.9-5.1-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M290.4,33.1c1.5,0.7,2.9,1.4,4.4,2.3c1.4,0.8,2.9,1.6,4.2,2.5l-2.1,3.5c-1.3-0.9-2.7-1.6-4.1-2.4 c-1.4-0.8-2.8-1.5-4.2-2.2L290.4,33.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M287.7,34.1c-1.8-0.8-3.5-1.6-5.3-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M281.3,29.3c1.5,0.6,3.1,1.1,4.6,1.8c1.5,0.7,3,1.3,4.5,2l-1.8,3.7c-1.4-0.7-2.8-1.3-4.3-2 c-1.4-0.7-2.9-1.2-4.4-1.8L281.3,29.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M278.8,30.5l-2.8-0.9c-0.9-0.3-1.8-0.6-2.8-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M272,26.3c1.6,0.4,3.2,0.8,4.7,1.4c1.6,0.5,3.1,1,4.6,1.6l-1.4,3.8c-1.5-0.6-3-1-4.4-1.5 c-1.5-0.5-3-0.9-4.5-1.3L272,26.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M269.6,27.7c-1.9-0.4-3.8-0.9-5.7-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M262.4,24.2c1.6,0.3,3.2,0.5,4.8,0.9c1.6,0.4,3.2,0.7,4.8,1.1l-1.1,3.9c-1.5-0.4-3-0.8-4.6-1.1 c-1.5-0.4-3.1-0.6-4.6-0.9L262.4,24.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M260.2,25.9c-1.9-0.2-3.8-0.5-5.8-0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M252.7,23.1c1.6,0.1,3.3,0.2,4.9,0.5c1.6,0.2,3.2,0.4,4.9,0.7l-0.7,4c-1.5-0.3-3.1-0.5-4.7-0.7 c-1.6-0.2-3.1-0.3-4.7-0.4L252.7,23.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M250.6,24.9c-1.9-0.1-3.9-0.1-5.8-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M242.9,22.8l2.5-0.1l2.5,0.1l2.5,0.1c0.8,0,1.6,0.1,2.4,0.2l-0.3,4.1c-0.8-0.1-1.6-0.1-2.3-0.2 l-2.4-0.1l-2.4-0.1l-2.4,0.1L242.9,22.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M241,24.9c-1.9,0.1-3.9,0.3-5.8,0.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M233.1,23.5c1.6-0.2,3.2-0.3,4.9-0.5c0.8-0.1,1.6-0.1,2.4-0.2l2.5-0.1l0.1,4.1l-2.4,0.1 c-0.8,0-1.6,0.1-2.3,0.2c-1.6,0.1-3.1,0.2-4.7,0.4L233.1,23.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M231.4,25.8c-1.9,0.2-3.8,0.6-5.7,0.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M223.4,25.1c1.6-0.4,3.2-0.6,4.8-0.9c1.6-0.3,3.2-0.5,4.9-0.7l0.5,4.1c-1.6,0.2-3.1,0.4-4.7,0.7 c-1.5,0.3-3.1,0.5-4.6,0.9L223.4,25.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M222,27.5c-1.9,0.4-3.7,1-5.6,1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M214,27.7c1.5-0.5,3.1-0.9,4.7-1.4c1.6-0.5,3.2-0.8,4.8-1.1l0.9,4c-1.5,0.3-3.1,0.7-4.6,1.1 c-1.5,0.4-3,0.8-4.5,1.3L214,27.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M212.7,30.2c-1.8,0.6-3.6,1.3-5.4,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M204.8,31.1c1.5-0.7,3-1.2,4.6-1.8c1.5-0.6,3.1-1.1,4.6-1.6l1.2,3.9c-1.5,0.5-3,0.9-4.4,1.5 c-1.5,0.6-2.9,1.1-4.4,1.8L204.8,31.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M203.8,33.7c-1.8,0.8-3.5,1.7-5.2,2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M196,35.4c1.4-0.8,2.9-1.5,4.4-2.3c1.5-0.8,3-1.4,4.5-2l1.6,3.8c-1.4,0.6-2.9,1.2-4.3,2 c-1.4,0.7-2.8,1.4-4.2,2.2L196,35.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M195.2,38.1c-1.7,1-3.3,2-4.9,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M187.6,40.5c0.7-0.5,1.3-0.9,2-1.4l2.1-1.3c1.4-0.9,2.8-1.7,4.2-2.5l2,3.6c-1.4,0.8-2.7,1.5-4.1,2.4 l-2,1.2c-0.7,0.4-1.3,0.9-1.9,1.3L187.6,40.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M187.2,43.3c-1.6,1.1-3.1,2.3-4.6,3.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "179.8,46.5 181.7,44.9 183.7,43.4 185.6,41.9 187.6,40.5 189.9,43.9 188,45.2 186.1,46.6  184.2,48.1 182.4,49.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M179.6,49.3c-1.4,1.3-2.9,2.6-4.2,4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M172.6,53.1c1.1-1.2,2.3-2.3,3.5-3.4l1.8-1.7c0.6-0.5,1.2-1.1,1.9-1.6l2.6,3.1c-0.6,0.5-1.2,1-1.8,1.5 l-1.7,1.6c-1.2,1-2.3,2.2-3.4,3.3L172.6,53.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M172.7,55.9l-1.9,2.2c-0.7,0.7-1.3,1.4-1.9,2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M166.1,60.5c1-1.3,2-2.6,3.2-3.8c1.1-1.2,2.2-2.5,3.3-3.6l2.9,2.9c-1.1,1.1-2.2,2.3-3.2,3.4 c-1.1,1.1-2,2.4-3,3.6L166.1,60.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M166.5,63.3c-1.1,1.6-2.3,3.1-3.4,4.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M160.4,68.4c1.8-2.7,3.7-5.4,5.7-8l3.2,2.5c-2,2.4-3.8,5-5.5,7.6L160.4,68.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M161,71.2c-1,1.7-2,3.3-2.9,5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M155.5,77c1.5-2.9,3.1-5.8,4.9-8.5l3.4,2.2c-1.7,2.6-3.2,5.4-4.7,8.1L155.5,77z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M156.4,79.6l-1.2,2.6c-0.4,0.9-0.7,1.8-1.1,2.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M151.5,85.9c0.6-1.5,1.2-3,1.9-4.5c0.7-1.5,1.4-3,2.1-4.4l3.6,1.8c-0.7,1.4-1.3,2.8-2,4.2 c-0.6,1.4-1.2,2.9-1.8,4.3L151.5,85.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "152.7,88.5 151.8,91.2 151,94  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M148.5,95.3l1.4-4.7c0.5-1.5,1.1-3.1,1.6-4.6l3.8,1.5c-0.5,1.5-1,3-1.6,4.4l-1.3,4.5L148.5,95.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "150,97.7 149.3,100.5 148.8,103.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "146.5,104.9 147.3,100.1 148.5,95.3 152.4,96.3 151.3,100.9 150.5,105.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "148.2,107.1 147.8,110 147.6,112.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "145.4,114.7 145.8,109.8 146.5,104.9 150.5,105.5 149.9,110.2 149.5,114.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "147.4,116.7 147.3,119.6 147.4,122.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "145.4,124.5 145.3,119.6 145.4,114.7 149.5,114.9 149.4,119.6 149.5,124.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "147.6,126.3 147.8,129.2 148.2,132.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "146.5,134.2 145.8,129.4 145.4,124.5 149.5,124.3 149.9,129 150.5,133.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "148.8,135.9 149.3,138.7 150,141.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "148.5,143.9 147.3,139.1 146.5,134.2 150.5,133.6 151.3,138.2 152.4,142.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M151,145.2c0.3,0.9,0.5,1.9,0.8,2.8l1,2.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M151.5,153.2c-0.6-1.5-1.1-3.1-1.6-4.6l-1.4-4.7l3.9-1.1l1.3,4.5c0.5,1.5,1,3,1.6,4.4L151.5,153.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M154.1,154.3c0.7,1.8,1.5,3.6,2.3,5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M155.5,162.2c-0.8-1.5-1.4-3-2.1-4.4c-0.7-1.5-1.3-3-1.9-4.5l3.8-1.5c0.6,1.4,1.2,2.9,1.8,4.3 c0.7,1.4,1.3,2.9,2,4.2L155.5,162.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M158.2,163c0.9,1.7,1.9,3.4,2.9,5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M160.4,170.7c-1.8-2.8-3.4-5.6-4.9-8.5l3.6-1.8c1.4,2.8,3,5.5,4.7,8.1L160.4,170.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M163.2,171.2c1,1.6,2.2,3.1,3.4,4.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M166.1,178.7c-2-2.6-3.9-5.2-5.7-8l3.4-2.2c1.7,2.6,3.5,5.2,5.5,7.6L166.1,178.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M168.9,178.9c1.2,1.5,2.6,2.9,3.8,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M172.6,186c-1.2-1.1-2.2-2.4-3.3-3.6c-1.1-1.2-2.1-2.5-3.2-3.8l3.2-2.5c1,1.2,2,2.5,3,3.6 c1,1.2,2.1,2.4,3.2,3.4L172.6,186z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M175.5,186c1.4,1.4,2.8,2.6,4.2,3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M179.8,192.7c-0.6-0.5-1.3-1-1.9-1.6l-1.8-1.7c-1.2-1.1-2.4-2.3-3.5-3.4l2.9-2.9 c1.1,1.1,2.2,2.2,3.4,3.3l1.7,1.6c0.6,0.5,1.2,1,1.8,1.5L179.8,192.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M182.6,192.4c1.5,1.2,3.1,2.4,4.6,3.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "187.6,198.6 185.6,197.2 183.7,195.7 181.7,194.3 179.8,192.7 182.4,189.6 184.2,191.1  186.1,192.5 188,193.9 189.9,195.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M190.4,198.1c1.6,1,3.3,2.1,4.9,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M196,203.8c-1.4-0.8-2.9-1.6-4.2-2.5l-2.1-1.3c-0.7-0.4-1.4-0.9-2-1.4l2.3-3.4 c0.6,0.4,1.3,0.9,1.9,1.3l2,1.2c1.3,0.9,2.7,1.6,4.1,2.4L196,203.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M198.7,202.9c1.7,0.8,3.4,1.8,5.2,2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M204.8,208.1c-1.5-0.7-3-1.3-4.5-2c-1.5-0.7-2.9-1.4-4.4-2.3l2-3.6c1.4,0.8,2.8,1.5,4.2,2.2 c1.4,0.7,2.8,1.3,4.3,2L204.8,208.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M207.4,207c1.8,0.7,3.6,1.4,5.4,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M214,211.5c-1.6-0.5-3.1-1-4.6-1.6c-1.5-0.6-3.1-1.1-4.6-1.8l1.6-3.8c1.4,0.7,2.9,1.2,4.4,1.8 c1.5,0.6,3,1,4.4,1.5L214,211.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M216.5,210.2c1.9,0.5,3.7,1.1,5.6,1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M223.4,214c-1.6-0.4-3.2-0.7-4.8-1.2c-1.6-0.4-3.2-0.8-4.7-1.4l1.2-3.9c1.5,0.5,3,0.9,4.5,1.3 c1.5,0.4,3,0.8,4.6,1.1L223.4,214z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M225.8,212.5c1.9,0.3,3.8,0.7,5.7,0.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M233.1,215.6c-1.6-0.2-3.2-0.4-4.9-0.7c-1.6-0.3-3.2-0.5-4.8-0.9l0.9-4c1.5,0.4,3.1,0.6,4.6,0.9 c1.5,0.3,3.1,0.5,4.7,0.7L233.1,215.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M235.3,213.9c1.9,0.1,3.9,0.3,5.8,0.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M242.9,216.3l-2.5-0.1c-0.8,0-1.6-0.1-2.4-0.2c-1.6-0.1-3.3-0.2-4.9-0.5l0.5-4.1 c1.6,0.2,3.1,0.3,4.7,0.4c0.8,0.1,1.6,0.1,2.3,0.2l2.4,0.1L242.9,216.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M244.9,214.3c1.9,0,3.9-0.1,5.8-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M252.7,216.1c-0.8,0.1-1.6,0.1-2.4,0.2l-2.5,0.1l-2.5,0.1l-2.5-0.1l0.1-4.1l2.4,0.1l2.4-0.1l2.4-0.1 c0.8,0,1.6-0.1,2.3-0.2L252.7,216.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M254.5,213.9c1.9-0.2,3.8-0.4,5.8-0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M262.4,214.9c-1.6,0.3-3.2,0.5-4.9,0.7c-1.6,0.2-3.2,0.3-4.9,0.5l-0.3-4.1c1.6-0.1,3.1-0.2,4.7-0.4 c1.6-0.2,3.1-0.4,4.7-0.7L262.4,214.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M264,212.6c1.9-0.3,3.8-0.8,5.7-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M272,212.9c-1.6,0.5-3.2,0.8-4.8,1.2c-1.6,0.4-3.2,0.6-4.8,0.9l-0.7-4c1.5-0.3,3.1-0.5,4.6-0.9 c1.5-0.3,3.1-0.7,4.6-1.1L272,212.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M273.4,210.4c1.9-0.5,3.7-1.2,5.5-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M281.3,209.9c-1.5,0.6-3.1,1.1-4.6,1.6c-1.5,0.5-3.1,0.9-4.7,1.4l-1.1-3.9c1.5-0.4,3-0.8,4.5-1.3 c1.5-0.5,3-0.9,4.4-1.5L281.3,209.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M282.5,207.3c1.8-0.7,3.6-1.5,5.3-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M290.4,206c-1.5,0.8-3,1.4-4.5,2c-1.5,0.7-3,1.2-4.6,1.8l-1.4-3.8c1.5-0.6,2.9-1.1,4.4-1.8 c1.4-0.6,2.9-1.2,4.3-2L290.4,206z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M291.2,203.3c1.7-0.9,3.4-1.9,5.1-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M298.9,201.3c-1.4,0.9-2.8,1.7-4.2,2.5c-1.4,0.8-2.9,1.5-4.4,2.3l-1.8-3.7c1.4-0.7,2.8-1.4,4.2-2.2 c1.4-0.8,2.7-1.5,4.1-2.4L298.9,201.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M299.6,198.5c1.6-1,3.2-2.2,4.8-3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M307,195.7l-2,1.5l-2,1.4c-0.7,0.5-1.3,0.9-2,1.4l-2.1,1.3l-2.1-3.5l2-1.2c0.7-0.4,1.3-0.9,1.9-1.3 l1.9-1.3l1.9-1.4L307,195.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M307.4,192.9c1.5-1.2,3-2.4,4.4-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M314.5,189.4l-1.8,1.7c-0.6,0.5-1.2,1.1-1.9,1.6l-1.9,1.6l-2,1.5l-2.5-3.3l1.9-1.4l1.8-1.5 c0.6-0.5,1.2-1,1.8-1.5l1.7-1.6L314.5,189.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M314.6,186.6c1.3-1.4,2.8-2.7,4-4.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M321.4,182.4c-1.1,1.2-2.2,2.5-3.3,3.6c-1.1,1.2-2.3,2.3-3.5,3.4l-2.8-3c1.2-1,2.3-2.2,3.4-3.3 c1.1-1.1,2.2-2.3,3.2-3.4L321.4,182.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M321.2,179.6c1.2-1.5,2.5-3,3.6-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M327.5,174.7c-1.9,2.7-3.9,5.2-6.1,7.7l-3.1-2.7c2.1-2.3,4-4.8,5.9-7.3L327.5,174.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M327,172c1.1-1.6,2.2-3.2,3.1-4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M332.8,166.5c-1.6,2.8-3.4,5.6-5.3,8.3l-3.3-2.4c1.8-2.5,3.5-5.2,5.1-7.9L332.8,166.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M332.1,163.8c0.9-1.7,1.8-3.4,2.6-5.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M337.3,157.7c-0.7,1.5-1.4,3-2.1,4.4c-0.8,1.4-1.5,2.9-2.3,4.3l-3.5-2c0.8-1.3,1.5-2.8,2.2-4.1 c0.7-1.4,1.3-2.8,2-4.2L337.3,157.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M336.2,155.1l1.1-2.7c0.3-0.9,0.6-1.8,1-2.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M340.8,148.6c-0.5,1.5-1.1,3.1-1.6,4.6c-0.6,1.5-1.2,3-1.9,4.5l-3.7-1.7c0.6-1.4,1.2-2.9,1.8-4.3 c0.5-1.5,1-3,1.6-4.4L340.8,148.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "339.5,146.1 340.3,143.3 340.9,140.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "343.3,139.1 342.2,143.9 340.8,148.6 336.9,147.3 338.3,142.8 339.4,138.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "341.7,136.7 342.3,133.9 342.6,131  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "344.9,129.4 344.2,134.2 343.3,139.1 339.4,138.2 340.2,133.6 340.8,129  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "343,127.2 343.2,124.3 343.3,121.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "345.4,119.6 345.3,124.5 344.9,129.4 340.8,129 341.2,124.3 341.3,119.6  "
  }))))))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178900226206509708040000016678843276815512750_)"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M218.9,357.9l-0.1-1.5c0-0.5-0.1-1-0.2-1.5c-0.2-1-0.2-2-0.5-2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M219.6,349.8l0.6,2.5c0.2,0.8,0.3,1.7,0.4,2.5l0.2,1.3c0,0.4,0,0.9,0.1,1.3l0.1,2.6h-4.1l-0.1-2.3 c0-0.4,0-0.8-0.1-1.1l-0.2-1.1c-0.1-0.8-0.2-1.5-0.3-2.3l-0.5-2.2L219.6,349.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M217.1,348.4c-0.6-1.9-1.4-3.7-2.3-5.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M215.6,340.3c1.8,2.9,3.1,6.2,4,9.4l-3.9,1.1c-0.8-2.9-1.9-5.8-3.6-8.4L215.6,340.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M212.8,339.7c-0.6-0.8-1.1-1.6-1.7-2.4c-0.6-0.7-1.3-1.5-1.9-2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M209.2,332.3c2.6,2.3,4.7,5.1,6.4,8l-3.5,2.1c-1.6-2.6-3.4-5.1-5.7-7.1L209.2,332.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M206.3,332.5c-0.8-0.6-1.5-1.2-2.3-1.8l-2.5-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M200.8,326.4c0.8,0.4,1.6,0.7,2.3,1.2l2.2,1.4c0.7,0.5,1.4,1,2,1.6l1,0.8l0.9,0.9l-2.8,3 c-2.2-2.1-4.7-3.9-7.5-5.2L200.8,326.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M198.1,327.4c-0.9-0.3-1.8-0.7-2.8-1l-2.8-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M190.9,323.3c0.8,0.2,1.7,0.2,2.5,0.5l2.5,0.7c0.8,0.2,1.6,0.6,2.4,0.9c0.4,0.2,0.8,0.3,1.2,0.5 l1.2,0.6l-1.8,3.7l-1-0.5c-0.3-0.2-0.7-0.3-1.1-0.4c-0.7-0.3-1.4-0.6-2.1-0.8l-2.2-0.6c-0.7-0.2-1.5-0.3-2.2-0.4 L190.9,323.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "188.7,325.1 185.7,324.9 182.8,325.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M180.6,323.3c1.7-0.4,3.4-0.3,5.2-0.4c1.7,0.1,3.5,0.1,5.2,0.4l-0.6,4c-1.5-0.3-3-0.3-4.5-0.4 c-1.5,0.1-3,0.1-4.5,0.4L180.6,323.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M179,325.7l-2.8,0.8c-0.9,0.3-1.8,0.7-2.7,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M170.8,326.4l1.2-0.6c0.4-0.2,0.8-0.3,1.2-0.5c0.8-0.3,1.6-0.7,2.4-0.9l2.5-0.7 c0.8-0.3,1.7-0.3,2.5-0.5l0.6,4c-0.7,0.1-1.5,0.2-2.2,0.4l-2.2,0.6c-0.7,0.2-1.4,0.5-2.1,0.8c-0.4,0.1-0.7,0.3-1.1,0.4 l-1,0.5L170.8,326.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M169.9,329.2l-2.5,1.6c-0.8,0.6-1.5,1.2-2.3,1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M162.3,332.3l0.9-0.9l1-0.8c0.7-0.5,1.3-1.1,2-1.6l2.2-1.4c0.7-0.5,1.5-0.8,2.3-1.2l1.8,3.7 c-2.8,1.3-5.2,3.1-7.5,5.2L162.3,332.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M162.3,335.2l-1.9,2.2c-0.6,0.8-1.1,1.6-1.7,2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M155.9,340.3c1.8-2.9,3.9-5.7,6.4-8l2.8,3c-2.3,2-4.1,4.5-5.7,7.1L155.9,340.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M156.6,343.1c-0.4,0.9-0.8,1.8-1.2,2.7c-0.4,0.9-0.7,1.8-1,2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M151.9,349.8c0.9-3.3,2.2-6.5,4-9.4l3.5,2.1c-1.6,2.6-2.7,5.5-3.6,8.4L151.9,349.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M153.4,352.2c-0.1,0.5-0.2,1-0.3,1.4l-0.2,1.5c-0.1,0.5-0.2,1-0.2,1.5l-0.1,1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M150.5,359.9l0.1-2.6c0-0.4,0-0.9,0.1-1.3l0.2-1.3c0.1-0.8,0.2-1.7,0.4-2.5l0.6-2.5l3.9,1.1l-0.5,2.2 c-0.1,0.8-0.2,1.5-0.3,2.3l-0.2,1.1c0,0.4,0,0.8-0.1,1.1l-0.1,2.3H150.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M152.6,361.9l0.1,1.5c0,0.5,0.1,1,0.2,1.5c0.2,1,0.2,2,0.5,2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M151.9,370.1l-0.6-2.5c-0.2-0.8-0.3-1.7-0.4-2.5l-0.2-1.3c0-0.4,0-0.9-0.1-1.3l-0.1-2.6h4.1l0.1,2.3 c0,0.4,0,0.8,0.1,1.1l0.2,1.1c0.1,0.8,0.2,1.5,0.3,2.3l0.5,2.2L151.9,370.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M154.4,371.4c0.6,1.9,1.4,3.7,2.3,5.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M155.9,379.5c-1.8-2.9-3.1-6.2-4-9.4l3.9-1.1c0.8,2.9,1.9,5.8,3.6,8.4L155.9,379.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M158.7,380.1c0.6,0.8,1.1,1.6,1.7,2.4c0.6,0.7,1.3,1.5,1.9,2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M162.3,387.5c-2.6-2.3-4.7-5.1-6.4-8l3.5-2.1c1.6,2.6,3.4,5.1,5.7,7.1L162.3,387.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M165.2,387.4c0.8,0.6,1.5,1.2,2.3,1.8l2.5,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M170.8,393.4c-0.8-0.4-1.6-0.7-2.3-1.2l-2.2-1.4c-0.7-0.5-1.4-1-2-1.6l-1-0.8l-0.9-0.9l2.8-3 c2.2,2.1,4.7,3.9,7.5,5.2L170.8,393.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M173.5,392.4c0.9,0.3,1.8,0.7,2.8,1l2.8,0.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M180.6,396.5c-0.8-0.2-1.7-0.2-2.5-0.5l-2.5-0.7c-0.8-0.2-1.6-0.6-2.4-0.9c-0.4-0.2-0.8-0.3-1.2-0.5 l-1.2-0.6l1.8-3.7l1,0.5c0.3,0.2,0.7,0.3,1.1,0.4c0.7,0.3,1.4,0.6,2.1,0.8l2.2,0.6c0.7,0.2,1.5,0.3,2.2,0.4L180.6,396.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "182.9,394.7 185.8,394.9 188.8,394.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M190.9,396.5c-1.7,0.4-3.4,0.3-5.2,0.4c-1.7-0.1-3.5-0.1-5.2-0.4l0.6-4c1.5,0.3,3,0.3,4.5,0.4 c1.5-0.1,3-0.1,4.5-0.4L190.9,396.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M192.6,394.2l2.8-0.8c0.9-0.3,1.8-0.7,2.7-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M200.8,393.4l-1.2,0.6c-0.4,0.2-0.8,0.3-1.2,0.5c-0.8,0.3-1.6,0.7-2.4,0.9l-2.5,0.7 c-0.8,0.3-1.7,0.3-2.5,0.5l-0.6-4c0.7-0.1,1.5-0.2,2.2-0.4l2.2-0.6c0.7-0.2,1.4-0.5,2.1-0.8c0.4-0.1,0.7-0.3,1.1-0.4l1-0.5 L200.8,393.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M201.6,390.7l2.5-1.6c0.8-0.6,1.5-1.2,2.3-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M209.2,387.5l-0.9,0.9l-1,0.8c-0.7,0.5-1.3,1.1-2,1.6l-2.2,1.4c-0.7,0.5-1.5,0.8-2.3,1.2l-1.8-3.7 c2.8-1.3,5.2-3.1,7.5-5.2L209.2,387.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M209.3,384.7l1.9-2.2c0.6-0.8,1.1-1.6,1.7-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M215.6,379.5c-1.8,2.9-3.9,5.7-6.4,8l-2.8-3c2.3-2,4.1-4.5,5.7-7.1L215.6,379.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M214.9,376.7c0.4-0.9,0.8-1.8,1.2-2.7c0.4-0.9,0.7-1.8,1-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M219.6,370.1c-0.9,3.3-2.2,6.5-4,9.4l-3.5-2.1c1.6-2.6,2.7-5.5,3.6-8.4L219.6,370.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M218.2,367.6c0.1-0.5,0.2-1,0.3-1.4l0.2-1.5c0.1-0.5,0.2-1,0.2-1.5l0.1-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M221,359.9l-0.1,2.6c0,0.4,0,0.9-0.1,1.3l-0.2,1.3c-0.1,0.8-0.2,1.7-0.4,2.5l-0.6,2.5l-3.9-1.1 l0.5-2.2c0.1-0.8,0.2-1.5,0.3-2.3l0.2-1.1c0-0.4,0-0.8,0.1-1.1l0.1-2.3H221z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178900226206509708040000016678843276815512750_)"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M562.7,389.9l-0.1-1.5c0-0.5-0.1-1-0.2-1.5c-0.2-1-0.2-2-0.5-2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M563.4,381.8l0.6,2.5c0.2,0.8,0.3,1.7,0.4,2.5l0.2,1.3c0,0.4,0,0.9,0.1,1.3l0.1,2.6h-4.1l-0.1-2.3 c0-0.4,0-0.8-0.1-1.1l-0.2-1.1c-0.1-0.8-0.2-1.5-0.3-2.3l-0.5-2.2L563.4,381.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M560.9,380.4c-0.6-1.9-1.4-3.7-2.3-5.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M559.4,372.3c1.8,2.9,3.1,6.2,4,9.4l-3.9,1.1c-0.8-2.9-1.9-5.8-3.6-8.4L559.4,372.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M556.6,371.7c-0.6-0.8-1.1-1.6-1.7-2.4c-0.6-0.7-1.3-1.5-1.9-2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M553,364.3c2.5,2.3,4.7,5.1,6.4,8l-3.5,2.1c-1.6-2.6-3.4-5.1-5.7-7.1L553,364.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M550.1,364.5c-0.8-0.6-1.5-1.2-2.3-1.8l-2.5-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M544.5,358.5c0.8,0.4,1.6,0.7,2.3,1.2l2.2,1.4c0.7,0.5,1.4,1,2,1.6l1,0.8l0.9,0.9l-2.8,3 c-2.2-2.1-4.7-3.9-7.5-5.2L544.5,358.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M541.8,359.4c-0.9-0.3-1.8-0.7-2.8-1l-2.8-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M534.7,355.4c0.8,0.2,1.7,0.2,2.5,0.5l2.5,0.7c0.8,0.2,1.6,0.6,2.4,0.9c0.4,0.2,0.8,0.3,1.2,0.5 l1.2,0.6l-1.8,3.7l-1-0.5c-0.3-0.2-0.7-0.3-1.1-0.4c-0.7-0.3-1.4-0.6-2.1-0.8l-2.2-0.6c-0.7-0.2-1.5-0.3-2.2-0.4 L534.7,355.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "532.4,357.1 529.5,356.9 526.6,357.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M524.4,355.4c1.7-0.4,3.4-0.3,5.2-0.4c1.7,0.1,3.5,0.1,5.2,0.4l-0.6,4c-1.5-0.3-3-0.3-4.5-0.4 c-1.5,0.1-3,0.1-4.5,0.4L524.4,355.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M522.7,357.7l-2.8,0.8c-0.9,0.3-1.8,0.7-2.7,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M514.6,358.5l1.2-0.6c0.4-0.2,0.8-0.3,1.2-0.5c0.8-0.3,1.6-0.7,2.4-0.9l2.5-0.7 c0.8-0.3,1.7-0.3,2.5-0.5l0.6,4c-0.7,0.1-1.5,0.2-2.2,0.4l-2.2,0.6c-0.7,0.2-1.4,0.5-2.1,0.8c-0.4,0.1-0.7,0.3-1.1,0.4 l-1,0.5L514.6,358.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M513.7,361.2l-2.5,1.6c-0.8,0.6-1.5,1.2-2.3,1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M506.1,364.3l0.9-0.9l1-0.8c0.7-0.5,1.3-1.1,2-1.6l2.2-1.4c0.7-0.5,1.5-0.8,2.3-1.2l1.8,3.7 c-2.8,1.3-5.2,3.1-7.5,5.2L506.1,364.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M506.1,367.2l-1.9,2.2c-0.6,0.8-1.1,1.6-1.7,2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M499.7,372.3c1.8-2.9,3.9-5.7,6.4-8l2.8,3c-2.3,2-4.1,4.5-5.7,7.1L499.7,372.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M500.4,375.1c-0.4,0.9-0.8,1.8-1.2,2.7c-0.4,0.9-0.7,1.8-1,2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M495.7,381.8c0.9-3.3,2.2-6.5,4-9.4l3.5,2.1c-1.6,2.6-2.7,5.5-3.6,8.4L495.7,381.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M497.2,384.2c-0.1,0.5-0.2,1-0.3,1.4l-0.2,1.5c-0.1,0.5-0.2,1-0.2,1.5l-0.1,1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M494.3,391.9l0.1-2.6c0-0.4,0-0.9,0.1-1.3l0.2-1.3c0.1-0.8,0.2-1.7,0.4-2.5l0.6-2.5l3.9,1.1l-0.5,2.2 c-0.1,0.8-0.2,1.5-0.3,2.3l-0.2,1.1c0,0.4,0,0.8-0.1,1.1l-0.1,2.3H494.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M496.4,393.9l0.1,1.5c0,0.5,0.1,1,0.2,1.5c0.2,1,0.2,2,0.5,2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M495.7,402.1l-0.6-2.5c-0.2-0.8-0.3-1.7-0.4-2.5l-0.2-1.3c0-0.4,0-0.9-0.1-1.3l-0.1-2.6h4.1l0.1,2.3 c0,0.4,0,0.8,0.1,1.1l0.2,1.1c0.1,0.8,0.2,1.5,0.3,2.3l0.5,2.2L495.7,402.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M498.2,403.5c0.6,1.9,1.4,3.7,2.3,5.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M499.7,411.5c-1.8-2.9-3.1-6.2-4-9.4l3.9-1.1c0.8,2.9,1.9,5.8,3.6,8.4L499.7,411.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M502.5,412.2c0.6,0.8,1.1,1.6,1.7,2.4c0.6,0.7,1.3,1.5,1.9,2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M506.1,419.5c-2.5-2.3-4.7-5.1-6.4-8l3.5-2.1c1.6,2.6,3.4,5.1,5.7,7.1L506.1,419.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M509,419.4c0.8,0.6,1.5,1.2,2.3,1.8l2.5,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M514.6,425.4c-0.8-0.4-1.6-0.7-2.3-1.2l-2.2-1.4c-0.7-0.5-1.4-1-2-1.6l-1-0.8l-0.9-0.9l2.8-3 c2.2,2.1,4.7,3.9,7.5,5.2L514.6,425.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M517.3,424.4c0.9,0.3,1.8,0.7,2.8,1l2.8,0.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M524.4,428.5c-0.8-0.2-1.7-0.2-2.5-0.5l-2.5-0.7c-0.8-0.2-1.6-0.6-2.4-0.9c-0.4-0.2-0.8-0.3-1.2-0.5 l-1.2-0.6l1.8-3.7l1,0.5c0.3,0.2,0.7,0.3,1.1,0.4c0.7,0.3,1.4,0.6,2.1,0.8l2.2,0.6c0.7,0.2,1.5,0.3,2.2,0.4L524.4,428.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "526.7,426.8 529.6,426.9 532.5,426.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M534.7,428.5c-1.7,0.4-3.4,0.3-5.2,0.4c-1.7-0.1-3.5-0.1-5.2-0.4l0.6-4c1.5,0.3,3,0.3,4.5,0.4 c1.5-0.1,3-0.1,4.5-0.4L534.7,428.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M536.4,426.2l2.8-0.8c0.9-0.3,1.8-0.7,2.7-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M544.5,425.4l-1.2,0.6c-0.4,0.2-0.8,0.3-1.2,0.5c-0.8,0.3-1.6,0.7-2.4,0.9l-2.5,0.7 c-0.8,0.3-1.7,0.3-2.5,0.5l-0.6-4c0.7-0.1,1.5-0.2,2.2-0.4l2.2-0.6c0.7-0.2,1.4-0.5,2.1-0.8c0.4-0.1,0.7-0.3,1.1-0.4l1-0.5 L544.5,425.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M545.4,422.7l2.5-1.6c0.8-0.6,1.5-1.2,2.3-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M553,419.5l-0.9,0.9l-1,0.8c-0.7,0.5-1.3,1.1-2,1.6l-2.2,1.4c-0.7,0.5-1.5,0.8-2.3,1.2l-1.8-3.7 c2.8-1.3,5.2-3.1,7.5-5.2L553,419.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M553,416.7l1.9-2.2c0.6-0.8,1.1-1.6,1.7-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M559.4,411.5c-1.8,2.9-3.9,5.7-6.4,8l-2.8-3c2.3-2,4.1-4.5,5.7-7.1L559.4,411.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M558.7,408.8c0.4-0.9,0.8-1.8,1.2-2.7c0.4-0.9,0.7-1.8,1-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M563.4,402.1c-0.9,3.3-2.2,6.5-4,9.4l-3.5-2.1c1.6-2.6,2.7-5.5,3.6-8.4L563.4,402.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M561.9,399.6c0.1-0.5,0.2-1,0.3-1.4l0.2-1.5c0.1-0.5,0.2-1,0.2-1.5l0.1-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M564.8,391.9l-0.1,2.6c0,0.4,0,0.9-0.1,1.3l-0.2,1.3c-0.1,0.8-0.2,1.7-0.4,2.5l-0.6,2.5l-3.9-1.1 l0.5-2.2c0.1-0.8,0.2-1.5,0.3-2.3l0.2-1.1c0-0.4,0-0.8,0.1-1.1l0.1-2.3H564.8z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M416.4,286.8c-3.3,0-6-2.7-6-6V249c0-3.6-3-6.6-6.6-6.6h-74.1c-3.6,0-6.6,3-6.6,6.6v27.1c0,3.3-2.7,6-6,6 s-6-2.7-6-6V249c0-10.2,8.3-18.6,18.6-18.6h74.1c10.2,0,18.6,8.3,18.6,18.6v31.8C422.4,284.1,419.7,286.8,416.4,286.8z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 406.6,
    y: 263.4,
    className: "st11",
    width: 20.1,
    height: 20.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 307.2,
    y: 263.4,
    className: "st11",
    width: 20.1,
    height: 20.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M541.3,292.2v155.6c0,10-8.1,18.2-18.2,18.2H231.1c-10,0-18.2-8.1-18.2-18.2V292.2c0-10,8.1-18.2,18.2-18.2 h292.1C533.2,274.1,541.3,282.2,541.3,292.2z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 251,
    y: 274.1,
    className: "st12",
    width: 17.6,
    height: 191.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481.5,
    y: 274.1,
    className: "st12",
    width: 17.6,
    height: 191.9
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000146501195916935636300000011303522349258148001_",
    d: "M541.5,292.3v155.6c0,10-8.1,18.2-18.2,18.2H231.3 c-10,0-18.2-8.1-18.2-18.2V292.3c0-10,8.1-18.2,18.2-18.2h292.1C533.4,274.1,541.5,282.2,541.5,292.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070837864235019962730000016234936780921946303_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000146501195916935636300000011303522349258148001_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000070837864235019962730000016234936780921946303_)",
      fill: "none",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    cx: 215.5,
    cy: 279.1,
    r: 20.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000070837864235019962730000016234936780921946303_)",
      fill: "none",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    cx: 537.9,
    cy: 460.5,
    r: 20.5
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M263.3,371.2h-7.2c-6.3,0-11.3-5.1-11.3-11.3v-17.2c0-6.3,5.1-11.3,11.3-11.3h7.2c6.3,0,11.3,5.1,11.3,11.3 v17.2C274.6,366.2,269.6,371.2,263.3,371.2z M256.1,334.4c-4.6,0-8.3,3.7-8.3,8.3v17.2c0,4.6,3.7,8.3,8.3,8.3h7.2 c4.6,0,8.3-3.7,8.3-8.3v-17.2c0-4.6-3.7-8.3-8.3-8.3H256.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 364.3,
    className: "st11",
    width: 3,
    height: 11.3
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M493.4,371.2h-7.2c-6.3,0-11.3-5.1-11.3-11.3v-17.2c0-6.3,5.1-11.3,11.3-11.3h7.2c6.3,0,11.3,5.1,11.3,11.3 v17.2C504.8,366.2,499.7,371.2,493.4,371.2z M486.3,334.4c-4.6,0-8.3,3.7-8.3,8.3v17.2c0,4.6,3.7,8.3,8.3,8.3h7.2 c4.6,0,8.3-3.7,8.3-8.3v-17.2c0-4.6-3.7-8.3-8.3-8.3H486.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.1,
    y: 364.3,
    className: "st11",
    width: 3,
    height: 11.3
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9356 -0.3532 0.3532 0.9356 -94.6618 135.4224)",
    className: "st2",
    cx: 323.8,
    cy: 327.1,
    rx: 17.1,
    ry: 17.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 323.9,
    cy: 327.3,
    r: 8.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 385,
    y: 311.4,
    className: "st2",
    width: 48.6,
    height: 19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.1,
    y: 318.4,
    className: "st12",
    width: 34.1,
    height: 5.2
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 431,
    cy: 127.8,
    r: 3.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 399.9,
    y1: 149.8,
    x2: 399.9,
    y2: 160.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 405.1,
    y1: 155.2,
    x2: 394.5,
    y2: 155.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M95.2,51c0,2.2-1.8,3.9-3.9,3.9c-2.2,0-3.9-1.8-3.9-3.9c0-2.2,1.8-3.9,3.9-3.9C93.5,47.1,95.2,48.8,95.2,51 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M671.7,79c0,2.2-1.8,3.9-3.9,3.9c-2.2,0-3.9-1.8-3.9-3.9c0-2.2,1.8-3.9,3.9-3.9 C670,75.1,671.7,76.9,671.7,79z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 694.8,
    y1: 99.4,
    x2: 694.8,
    y2: 109.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 700,
    y1: 104.8,
    x2: 689.5,
    y2: 104.8
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M321.3,199.9h63c0,0-12.8-15.5-20.6-12.8c-7.8,2.8-6.4,15.6-18.5,8.2C330.1,186.1,321.3,199.9,321.3,199.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M104.8,183.5h41.4c0,0-6.1-8.6-13.4-7.2c-5.3,1.1-6.1,4.6-11.5,3.6C109.8,177.7,104.8,183.5,104.8,183.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M180.8,286.7c-7.2,1.5-8.2,7.7-17.6-1.3c-5.2-5-13.4-8.1-19.1-6.4c-10.5,3.1-12.8,18.5-28.8,9.9 c-16-8.6-21.7,4.2-21.7,4.2h78.1h19.1C190.8,293.1,188.4,285.1,180.8,286.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M616.5,145.4c-3,0.8-6.6,1.1-11.9-0.3c-4.1-1.1-6.8-2.7-8.9-3.5c-10.6-3.9-15.9,7.4-15.9,7.4h32.9h8 C620.7,148.9,619.7,144.5,616.5,145.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M608.1,217.7c-5.4,1.2-6.2,6-13.2-1c-3.9-3.9-10.1-6.4-14.3-5.1c-7.8,2.4-9.6,14.6-21.6,7.8 c-12-6.8-16.2,3.3-16.2,3.3h58.6h14.3C615.6,222.7,613.8,216.4,608.1,217.7z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M337.2,152.6c-0.2,3.5-3.1,6.1-6.6,5.9c-3.5-0.2-6.1-3.1-5.9-6.6c0.2-3.5,3.1-6.1,6.6-5.9 C334.7,146.2,337.4,149.2,337.2,152.6z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 331.5,
    y1: 142.3,
    x2: 332,
    y2: 132.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 322.7,
    y1: 146.9,
    x2: 314.4,
    y2: 141.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 321.2,
    y1: 151.8,
    x2: 311.3,
    y2: 151.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 325.9,
    y1: 160.5,
    x2: 320.4,
    y2: 168.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 330.8,
    y1: 162,
    x2: 330.5,
    y2: 167.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 335.7,
    y1: 160.9,
    x2: 340.3,
    y2: 169.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 339.5,
    y1: 157.4,
    x2: 347.9,
    y2: 162.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 339.8,
    y1: 147.5,
    x2: 348.7,
    y2: 143
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 336.4,
    y1: 143.8,
    x2: 339.3,
    y2: 139
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M286.5,219.4c0-6.8-5.5-12.3-12.3-12.3c-6.8,0-12.3,5.5-12.3,12.3c0,1.7,0.3,3.2,0.9,4.7l10.9,22l11.8-22 C286.2,222.6,286.5,221.1,286.5,219.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M268.6,219.5c0,3.1,2.5,5.7,5.7,5.7s5.7-2.5,5.7-5.7s-2.5-5.7-5.7-5.7S268.6,216.3,268.6,219.5z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M254.9,143.9c0-26.1-21.2-47.3-47.3-47.3s-47.3,21.2-47.3,47.3c0,8.5,2.3,16.5,6.2,23.4l-0.3,0l26.9,46.3 h28.9l27.1-46.9l-0.1,0C252.8,159.9,254.9,152.1,254.9,143.9z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "193.9,213.6 202.2,229.9 212.7,229.9 221.4,213.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M207.4,241.1L207.4,241.1c-3.3,0-6-2.7-6-6v-5.6h12v5.6C213.4,238.4,210.7,241.1,207.4,241.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M214.4,213.6l11.8-46.9l-0.1,0c1.6-6.8,2.6-14.6,2.6-22.8c0-26.1-9.2-47.3-20.5-47.3 c-11.3,0-20.5,21.2-20.5,47.3c0,8.5,1,16.5,2.7,23.4l-0.1,0l11.7,46.3"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "87.8,466.1 175.7,333.3 268.3,466.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "160.2,466 175.1,408.6 197,466.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "175.1,408.6 146.4,465.9 160.2,466  "
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 42.1,
    y1: 466.2,
    x2: 705.2,
    y2: 466.2
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M436.5,481H297c-6.7,0-12.2-5.4-12.2-12.2v-78.7c0-6.7,5.4-12.2,12.2-12.2h139.5c6.7,0,12.2,5.4,12.2,12.2 v78.7C448.6,475.6,443.2,481,436.5,481z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.2,
    y: 371.5,
    className: "st21",
    width: 24.1,
    height: 12.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.5,
    y: 374.5,
    className: "st21",
    width: 15.9,
    height: 8.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M465.1,390.2v78.7c0,6.7-5.4,12.2-12.1,12.2H313.5c-6.7,0-12.2-5.5-12.2-12.2v-78.7 c0-6.7,5.5-12.2,12.2-12.2H453C459.7,378,465.1,383.4,465.1,390.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M388.2,359.9h-18.5c-3.7,0-6.9,2.3-8.1,5.8l-6.5,18.7h47.3l-5.9-18.4C395.3,362.3,392,359.9,388.2,359.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M365.9,378l3.3-9.6c0.5-1.4,1.8-2.3,3.2-2.3h12.9c1.5,0,2.8,1,3.2,2.4l3,9.5H365.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 406.9,
    className: "st24",
    width: 164.1,
    height: 43
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st21",
    cx: 371.4,
    cy: 429.3,
    r: 35.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.3,
    y: 393.8,
    className: "st21",
    width: 18.4,
    height: 71.1
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st25",
    cx: 388.3,
    cy: 429.3,
    r: 35.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st23",
    cx: 388.5,
    cy: 428.9,
    r: 20.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M393.1,422c0,1.7,1.4,3.1,3.1,3.1c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1 C394.5,418.9,393.1,420.3,393.1,422z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M388.7,436.2c0,3.2-2.6,5.8-5.8,5.8s-5.8-2.6-5.8-5.8c0-3.2,2.6-5.8,5.8-5.8S388.7,433,388.7,436.2z"
  })))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 249.1,
    y1: 481.1,
    x2: 498.2,
    y2: 481.1
  })), /*#__PURE__*/React.createElement("g", null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M411.6,259.1v10.4c0,2.6-2.1,4.7-4.7,4.7h-37.7c-1.7,0-3.1-1.5-3.1-3.2l0,0c0.1-1.2,0.8-2.2,1.8-2.7 l28.3-12.4L411.6,259.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M455.7,162.6l1-8.1c0.7-5.8,6-9.8,11.7-9l31.1,4.3c5.2,0.7,9,5.2,8.9,10.5l-0.1,6L455.7,162.6z"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M605,413.4l-63.8-11.3c0,0,1.5-7,3.4-15.2c2.5-11.1,5.5-24.4,5.8-24.9l23.4-12.5c0,0,3.5,32.7,4.6,34.6 c3.5,6.4,13.1,15.1,20.4,18.9C608.1,408,605,413.4,605,413.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M608,414.1l-68.7-12.2c0,0,1.3-5.9,3-13.3c0.4-1.7,2-2.8,3.7-2.4l24.3,5c1.6-3.7,4.1-6,6.4-7.4 c1.3-0.8,3-0.3,3.9,0.9c4.5,6.6,13.6,14.6,20.6,18.3C611.4,408.3,608,414.1,608,414.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M575.9,403.3c0,0,1.4-7,10.3-11.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st27",
    x1: 540.7,
    y1: 397.1,
    x2: 608.1,
    y2: 410.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M576.7,392.1c0,0,2.8-3.8,5.7-4.6"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "499,190.6 544.9,202.7 544.3,174 500.1,157.6  "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M547,143.4l-2.5-13.4c-0.3-1.4-1-2.5-2.2-3.3l-5.5-3.7l-3.4,2.8l-9.9,19.6l8.6,4.3L547,143.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M541.8,134.2c-0.5,7.2-6.8,12.7-14,12.2c-7.2-0.5-12.7-6.8-12.2-14c0.5-7.2,6.8-12.7,14-12.2 c5.4,0.4,9.7,3.9,11.4,8.7C541.7,130.5,541.9,132.3,541.8,134.2z"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M478.4,130.1l-1.8-6.9c-1.7-6.5,3.4-12.7,10.1-12.4l18.2,0.9c3.1,0.2,5.4,2.8,5.2,5.9l0,0 c-0.2,3-2.8,5.3-5.9,5.1l-20.5-1.4l-0.6,8.7C483,129.9,478.5,130.1,478.4,130.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 482.1,
    y: 138,
    transform: "matrix(0.9976 6.976154e-02 -6.976154e-02 0.9976 11.5012 -33.7906)",
    className: "st10",
    width: 14.8,
    height: 19.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M493.2,146.8L493.2,146.8c-6.3-0.4-11-5.9-10.5-12.1l1-13.9l22.7,1.6l-1,13.9 C504.9,142.5,499.5,147.2,493.2,146.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M476,132.8c-0.2,2.6,1.8,4.9,4.4,5.1c2.6,0.2,4.9-1.8,5.1-4.4c0.2-2.6-1.8-4.9-4.4-5.1 C478.5,128.2,476.2,130.2,476,132.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M491.1,144.9c0,0,1.7,1.7,5.8,1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M489,124.5c-0.2,2.7-2.5,4.7-5.1,4.5c-2.7-0.2-4.7-2.5-4.5-5.1c0.2-2.7,2.5-4.7,5.1-4.5 C487.2,119.6,489.2,121.9,489,124.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M478.7,134.5c-0.1-0.3-0.2-0.7-0.2-1.1c0.1-1.3,1.2-2.2,2.5-2.1c0.1,0,0.2,0,0.3,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M494.6,130.7c-0.1,0.8-0.5,1.4-1,1.4c-0.5,0-0.9-0.7-0.8-1.5c0.1-0.8,0.5-1.4,1-1.4 C494.3,129.2,494.7,129.9,494.6,130.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M503.4,131.4c-0.1,0.8-0.5,1.4-1,1.4c-0.5,0-0.9-0.7-0.8-1.5c0.1-0.8,0.5-1.4,1-1.4 C503.1,129.9,503.5,130.5,503.4,131.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M495.5,126.6c0,0.6-0.7,0.5-1.8,0.6c-1.1,0.1-2.2,0.3-2.3-0.3c0-0.6,0.8-1.1,2-1.2 C494.5,125.6,495.5,126,495.5,126.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M505.2,127.7c-0.1,0.6-0.8,0.3-1.9,0.1c-1.1-0.2-2.2-0.2-2.1-0.8c0.1-0.6,1.1-0.9,2.2-0.7 C504.4,126.5,505.2,127.1,505.2,127.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M499.4,129.9l0.3,5.6c0,0.7-0.5,1.2-1.2,1.2c-0.6,0-1.3-0.1-1.2-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M492.4,138.5c0,0,0.4,1.7,2.1,2.3"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M515.4,140.5c-4.3-0.3-7.5-4-7.2-8.3c0.3-4.3,4-7.5,8.3-7.2c4.3,0.3,7.5,4,7.2,8.3 C523.4,137.6,519.7,140.8,515.4,140.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516,
    y: 125.4,
    transform: "matrix(0.9976 6.975779e-02 -6.975779e-02 0.9976 10.5658 -36.1254)",
    className: "st28",
    width: 13,
    height: 15.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M528.6,141.4c-4.3-0.3-7.5-4-7.2-8.3c0.3-4.3,4-7.5,8.3-7.2c4.3,0.3,7.5,4,7.2,8.3 C536.6,138.5,532.8,141.7,528.6,141.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M533.7,134c-0.2,2.5-2.4,4.5-4.9,4.3c-2.5-0.2-4.5-2.4-4.3-4.9c0.2-2.5,2.4-4.5,4.9-4.3 C532,129.2,533.9,131.4,533.7,134z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M498.8,139.3c-4.3-0.3-7.5-4-7.2-8.3c0.3-4.3,4-7.5,8.3-7.2c4.3,0.3,7.5,4,7.2,8.3 C506.8,136.4,503,139.6,498.8,139.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.3,
    y: 124.3,
    transform: "matrix(0.9976 6.976488e-02 -6.976488e-02 0.9976 10.445 -34.969)",
    className: "st28",
    width: 13,
    height: 15.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M511.9,140.2c-4.3-0.3-7.5-4-7.2-8.3c0.3-4.3,4-7.5,8.3-7.2c4.3,0.3,7.5,4,7.2,8.3 C519.9,137.3,516.2,140.5,511.9,140.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M517,132.8c-0.2,2.5-2.4,4.5-4.9,4.3c-2.5-0.2-4.5-2.4-4.3-4.9c0.2-2.5,2.4-4.5,4.9-4.3 C515.3,128.1,517.2,130.3,517,132.8z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M531,145l3.6,44c0.6,7.4,7.5,12.7,14.8,11.4h0c7.6-1.4,12.1-9.2,9.6-16.5l-12.8-42.8L531,145z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M542.1,203.1l-26.4-7.2l5.9,70.8L438.4,255l3.6-38l-23.7,39.7c-2.3,3.8-6.8,5.6-11,4.5l-11.7-3.2 c-6.3-1.7-9.2-8.9-5.9-14.5l41.5-70.4c9.2-13.5,24.9-21,41.2-19.6l5.7,0.5l22.2,1.9l2.9,0.3c5.7,0.5,11.3,1.9,16.6,4.2l11.5,5 l-3.6-12.1l22.7-3.7l9.5,35.7C562.9,196.1,553,206,542.1,203.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M507.8,156.2l-9.4,17.5c-3.8,7-13.7,7.6-18.2,1L465,152.5l6.1,0.5l29.8,2.6L507.8,156.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M496.4,155.2l-3.3,6c-1.3,2.4-4.7,2.6-6.3,0.3l-5.2-7.6l2.1,0.2L494,155L496.4,155.2z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st27",
    x1: 515.7,
    y1: 195.9,
    x2: 514.9,
    y2: 188.3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st27",
    x1: 531.3,
    y1: 165.3,
    x2: 533.1,
    y2: 172.5
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "528.1,154.5 526.6,149.1 549.4,144.8 550.7,150.5  "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M493,120.5c-0.1,1.9-1.8,3.4-3.8,3.3c-1.9-0.1-3.4-1.8-3.3-3.8c0.1-1.9,1.8-3.4,3.8-3.3 C491.7,116.9,493.1,118.6,493,120.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000041258269578847283280000010311840566521361286_",
    d: "M542.1,203.1l-26.4-7.2l5.9,70.8L439.2,249l4.5-35.4 l-23.5,40.7l-29.5-12.8l40.5-68.4c9.2-13.5,24.9-21,41.2-19.6l5.7,0.5l22.2,1.9l2.9,0.3c5.7,0.5,11.3,1.9,16.6,4.2l11.5,5 l-3.6-12.1l22.7-3.7l9.5,35.7C562.9,196,553,206,542.1,203.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078723931877818190230000016016229583447779487_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000041258269578847283280000010311840566521361286_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000078723931877818190230000016016229583447779487_)",
      fill: "none",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    d: " M570.4,200.5c-0.5,7.3-6.8,12.7-14.1,12.2c-7.3-0.5-12.7-6.8-12.2-14.1c0.5-7.3,6.8-12.7,14.1-12.2 C565.4,187,570.9,193.3,570.4,200.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000078723931877818190230000016016229583447779487_)",
      fill: "none",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    d: " M452.6,228.3c-0.5,7.3-6.8,12.7-14.1,12.2c-7.3-0.5-12.7-6.8-12.2-14.1c0.5-7.3,6.8-12.7,14.1-12.2 C447.7,214.7,453.2,221,452.6,228.3z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "471.4,127.8 514.8,114.6 506.3,110.7 498.9,99.3 472.3,110.3 475.3,120  "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M518.4,228.3l-23.5,6c-4.1,10,1.4,21.3,11.8,24.2l28.5,8l7.2,105.3l44.6-0.1l-6.7-111.3 c-0.5-8.5-6.3-15.8-14.5-18.3L518.4,228.3z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "522.1,245.4 517.5,245.5 477.9,246.7 439.5,247.9 437.9,244.7 438.4,241.3 439.1,236.7 440.2,229.5  518.8,228.7  "
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M568.5,422.4L511.8,391c0,0,3.7-6.1,8.1-13.2c6-9.7-20.4-64.3,1.4-51.8l20.5,15.2c0,0,10.6,42.8,11,45 c1.2,7.2,7.5,18.6,13.1,24.5C573.2,418.3,568.5,422.4,568.5,422.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M571.1,424.1l-61-33.9c0,0,3.1-5.1,7.1-11.6c0.9-1.5,2.8-1.9,4.3-1.1l21.4,12.6c2.8-3,5.8-4.3,8.5-4.9 c1.5-0.3,3,0.7,3.4,2.1c2.1,7.7,8.1,18.2,13.6,24C576.2,419.7,571.1,424.1,571.1,424.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M544.2,403.4c0,0,3.6-6.2,13.4-7.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st27",
    x1: 513,
    y1: 386.1,
    x2: 572.4,
    y2: 420.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M548.6,393.1c0,0,3.9-2.6,6.9-2.5"
  })))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M559,376.5l-15.1-0.8l-25.4-1.4L504,288.9l-45.4-9.8c-12-2.6-20.6-13.2-20.6-25.5l0-8.9l0.5-3.4l38.6,1 l30.1,0.8c2.8,0.1,6.5,0.9,10.3,2.4c7.9,3,33.1,29.4,34.9,34.9L559,376.5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M483,168.4c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6 C482.3,166.8,483,167.5,483,168.4z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M500.2,168.6c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6 C499.5,167,500.2,167.7,500.2,168.6z"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 481.3,
    y1: 169.2,
    x2: 476.2,
    y2: 207.2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 498.7,
    y1: 169.3,
    x2: 499.6,
    y2: 201.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M505.9,110.3c0,0-30.1,9.8-30.6,9.7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M508.7,239.8l31.3,13c7.4,3.1,12.4,10.1,12.9,18.1l5.7,101.4"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st27",
    x1: 550.9,
    y1: 376.4,
    x2: 552.5,
    y2: 385
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M398.2,266.4l-10.1,3c-1,0.3-1.6,1.2-1.6,2.2l0,2.4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M543.9,375.7l-20.1-1.1l-5.3-0.3l-10-58.9l-4.5-26.6l-45.4-9.8c-12-2.6-20.6-13.2-20.6-25.5l0-8.9l0.5-3.4 l0.7-4.6l37.7,4.3l0.3,1.4l0.8,4c0,0.2,0.1,0.3,0.1,0.4c1.2,5.7,5.7,10.3,11.4,11.7l37.7,9.4c3.9,1,6.8,4.3,7.1,8.3L543.9,375.7z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M533.4,375l-9.3-88.6c-0.5-4.7-3.9-8.6-8.6-9.7l-46.7-11.1c-5.6-1.3-9.6-6.2-10-11.9l-0.9-15"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M439,221.8l-1.9,17.4l22.4,9.5c4.1,1.8,8.9,1.3,12.6-1.2l7.5-5c4.3-2.9,9.5-4.1,14.6-3.5l0,0 c5.3,0.6,10.6-0.7,14.9-3.7l9.6-6.6l-1.6-11.8l-71-8.3L439,221.8z"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st27",
    x1: 439.4,
    y1: 221.9,
    x2: 453.3,
    y2: 194.3
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M523.8,374.6l-5.3-0.3l-10-58.9l5.5,3.1c2,1.1,3.3,3.1,3.6,5.3L523.8,374.6z"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "TEXTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M90.7,238.2h42.8c0,0-6.5-13.8-12.1-9.4c-8.1,6.3-10.6,8.6-19.2,4.2C96.3,230,90.7,238.2,90.7,238.2z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st34",
    x1: 102,
    y1: 250.5,
    x2: 66.4,
    y2: 250.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M615,258.2h48.2c0,0-7.3-15.5-13.7-10.6c-9.2,7-12,9.7-21.6,4.8C621.3,248.9,615,258.2,615,258.2z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st34",
    x1: 645.7,
    y1: 271.4,
    x2: 683.6,
    y2: 271.4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUs2);
export default __webpack_public_path__ + "static/media/aboutUs-2.07213ec378bc4d6cbc91bbdfae50899a.svg";
export { ForwardRef as ReactComponent };